import React from "react";
import { createRoot } from "react-dom/client";
import { FontPreloader } from "@livingmap/hippo";

import App from "./App";
import "./i18n"; // Import the i18n configuration

import reportWebVitals from "./reportWebVitals";
import "./index.scss";

// Redux imports
import { store } from "./store";
import { Provider } from "react-redux";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <FontPreloader />
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
